module.exports = __webpack_public_path__ + "img/CC1001.21ceb390.png";